module.exports = __webpack_public_path__ + "media/images/icons/envelope-7237e68b9cc61c6a0be3cccbb522e4c6.svg";